(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MyTripsShare',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// show details for travel type if checked
		$(".include-additional").on('click', function additional(e) {
			var $self       = $(this),
			    checked     = $self.is(':checked'),
			    travel_type = $self.data('type');

			toggleAdditionalDetails();

			if (checked === true) {
				$('.additional-details-' + travel_type).removeClass('hidden');
			} else {
				$('.additional-details-' + travel_type).addClass('hidden');
			}
		});
	};

	// if any of the other travel types are checked, show the #additional-components parent div
	function toggleAdditionalDetails()
	{
		var any_checked = false;

		$(".include-additional").each(function loopChecks(i) {
			if ($(this).is(':checked') === true) {
				any_checked = true;
				return false;
			}
		});

		if (any_checked === true) {
			$('#additional-components').removeClass('hidden');
			return;
		}
		$('#additional-components').addClass('hidden');
	}
}(jQuery, window.Adzuki || {}));
